<script setup>

defineProps(['icon', 'iconClasses', 'title', 'desc']);

</script>

<template>
  <div class="sm:flex lg:block">
    <div class="sm:flex-shrink-0">
      <component
        :is="icon"
        class="w-14 text-secondary"
        :class="iconClasses"
      />
    </div>
    <div class="mt-4 sm:ml-6 sm:mt-0 lg:ml-0 lg:mt-6">
      <h4 class="text-md font-bold">
        {{ title }}
      </h4>
      <p class="mt-2 text-sm">
        {{ desc }}
      </p>
    </div>
  </div>
</template>

<style scoped>

</style>
